module.exports = __webpack_public_path__ + "static/media/indexBg2.2ba85333.png";